import { render, staticRenderFns } from "./TreesDialog.vue?vue&type=template&id=8fe575a4"
import script from "./TreesDialog.vue?vue&type=script&lang=js"
export * from "./TreesDialog.vue?vue&type=script&lang=js"
import style0 from "./TreesDialog.vue?vue&type=style&index=0&id=8fe575a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports